import {
	HStack,
	Box,
	Icon,
	Text,
	Grid,
	GridItem,
	Flex,
	CircularProgress,
	CircularProgressLabel,
	Card,
	Tooltip,
	useToast,
} from '@chakra-ui/react'
import { RAGStatus } from '../RAGStatus'
import { CiClock2 } from 'react-icons/ci'
import { IoIosArrowForward } from 'react-icons/io'
import { getTimeFromNow } from '../../../utils/date.utils'
import { useEffect, useState } from 'react'
import { useLanguageContext } from './../../../context/locale.context'
import { format } from 'date-fns'
import SVGIcon from './../../../assets/svgIcons/index'

const ActivityListItem = ({
	activity,
	selectedActivity,
	onSelect,
	selectedActivities = [],
}) => {
	const {
		state: { locale },
	} = useLanguageContext()

	const toast = useToast({
		duration: 1000,
	})

	const {
		activity_title,
		activity_type_category_name,
		activity_type_name,
		activity_status_name,
		activity_cuid_1,
		activity_datetime_end_deferred,
		asset_unread_updates_count,
		activity_workflow_completion_percentage: completion,
		activity_sub_type_id,
		activity_datetime_last_updated,
		participant_list,
		activity_lead_operating_asset_first_name,
	} = activity

	const [timePassed, setTimePassed] = useState(
		getTimeFromNow(activity_datetime_last_updated)
	)

	useEffect(() => {
		const interval_time = 1000
		// Setting time passed every 1 second, otherwise too many rerenders happening
		const timePassedInterval = setInterval(
			() => setTimePassed(getTimeFromNow(activity_datetime_last_updated)),
			interval_time
		)

		return () => clearInterval(timePassedInterval)
	}, [activity_datetime_last_updated])

	const timeColor = datetime => {
		let isDelayed =
			new Date(datetime?.split(' ')?.join('T')).setHours(0, 0, 0, 0) <
			new Date().setHours(0, 0, 0, 0)
		if (!!isDelayed) {
			return 'red'
		} else {
			return 'green'
		}
	}

	const showDateCalendar = date => {
		const formattedDate =
			date?.includes('date') || date?.includes('0000-00-00')
				? date
				: format(
						new Date(
							date?.split(' ')?.join('T') +
								(date?.includes('00Z') ? '' : '.00Z')
						),
						'dd MMM yyyy'
				  )
		const color = timeColor(activity_datetime_end_deferred)

		return (
			<Box w='28px' color='black'>
				<Box
					w='100%'
					pb='100%'
					borderRadius='5px'
					h='0'
					boxShadow='0px 2px 2px rgba(0, 0, 0, 0.1)'
					overflow='hidden'
				>
					<Flex
						bg={color === 'red' ? '#ED303B' : '#179B5F'}
						fontSize='10px'
						color='white'
						borderTopRightRadius='5px'
						borderTopLeftRadius='5px'
						justifyContent='center'
						lineHeight='1.4'
					>
						{formattedDate?.split(' ')?.[1]}
					</Flex>
					<Flex justifyContent='center' fontSize='12px' lineHeight='1.3'>
						{formattedDate?.split(' ')?.[0]}
					</Flex>
				</Box>
			</Box>
		)
	}

	const showActivityDetails = () => {
		let ownersList = ''
		participant_list?.forEach(participant => {
			if (participant.asset_flag_is_owner === 1) {
				ownersList = ownersList.concat(
					participant.operating_asset_first_name,
					', '
				)
			}
		})
		ownersList = ownersList.slice(0, -2)
		const gridItems = [
			{
				label: activity_type_category_name,
				value: activity_type_name,
			},
			{
				label: locale['Status'],
				value: activity_status_name,
			},
			{
				label: !!activity_lead_operating_asset_first_name
					? locale['Lead']
					: locale['Owner'],
				value: !!activity_lead_operating_asset_first_name
					? activity_lead_operating_asset_first_name
					: ownersList,
			},
			{
				label: locale['CUID'],
				value: activity_cuid_1,
				onClick: e => {
					e.stopPropagation()
					navigator.clipboard.writeText(activity_cuid_1)
					toast({
						title: 'Copied!',
						status: 'success',
					})
				},
			},
		]
		return (
			<Grid
				templateColumns='1fr 0.2fr 4fr'
				pt='0.625rem'
				gap='6px'
				alignItems='start'
				fontSize='0.75rem'
			>
				{gridItems.map(item => {
					return (
						<>
							{/* { !! item.value ? */}
							<>
								<GridItem>
									<Text
										fontWeight='500'
										color='rgba(0,0,0,0.5)'
										className={'activity-card-category-name'}
									>
										{item.label}
									</Text>
								</GridItem>
								<GridItem>
									<Text>:</Text>
								</GridItem>
								<GridItem>
									<Tooltip
										label='Copy'
										color='black'
										bg='#F5F5F5'
										boxShadow='0px 6px 20px rgba(24, 39, 75, 0.2), 0px 10px 32px rgba(24, 39, 75, 0.1)'
										isDisabled={item.label !== locale['CUID']}
									>
										<Text
											fontWeight='400'
											color='rgba(0,0,0)'
											onClick={e => {
												if (!!item.onClick) item.onClick(e)
											}}
										>
											{item.value}
										</Text>
									</Tooltip>
								</GridItem>
							</>
							{/* :null} */}
						</>
					)
				})}
			</Grid>
		)
	}

	return (
		<Card
			borderRadius='10px'
			mt='1rem'
			p={0}
			w='100%'
			bg={
				!!selectedActivity &&
				selectedActivity.activity_id === activity.activity_id
					? 'white'
					: 'secondary'
			}
			border={
				!!selectedActivity &&
				selectedActivity.activity_id === activity.activity_id
					? '1px'
					: 'none'
			}
			boxShadow={
				!!selectedActivity &&
				selectedActivity.activity_id === activity.activity_id
					? '0px 6px 14px -6px rgba(24, 39, 75, 0.12)'
					: '0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1)'
			}
			borderColor='#FFE36D'
			cursor='pointer'
			onClick={() => {
				onSelect(activity)
			}}
		>
			<Grid
				templateColumns='5fr 1fr'
				mb='1.25rem'
				padding='1.25rem 1.25rem 0 1.25rem'
			>
				<GridItem>
					<Box
						fontWeight='500'
						fontSize='16px'
						mb={1}
						textOverflow='ellipsis'
						color='brand.900'
					>
						<HStack alignItems='center'>
							<RAGStatus activity={activity} />
							<Tooltip
								label='Copy'
								color='black'
								bg='#F5F5F5'
								boxShadow='0px 6px 20px rgba(24, 39, 75, 0.2), 0px 10px 32px rgba(24, 39, 75, 0.1)'
							>
								<Text
									as='span'
									textTransform='capitalize'
									wordBreak='break-all'
									onClick={e => {
										e.stopPropagation()
										navigator.clipboard.writeText(activity_title)
										toast({
											title: 'Copied!',
											status: 'success',
										})
									}}
								>
									{activity_title}
								</Text>
							</Tooltip>
							{activity_sub_type_id === 1 && (
								<Icon
									zIndex={1}
									as={IoIosArrowForward}
									onClick={e => {
										e.stopPropagation()
									}}
									w={4}
									h={4}
									ml='auto'
								/>
							)}
						</HStack>
					</Box>
					{showActivityDetails()}
				</GridItem>
				<Grid justifyContent='end' gap='1.5rem'>
					<GridItem>
						{showDateCalendar(activity_datetime_end_deferred)}
					</GridItem>
					<GridItem>
						{!!asset_unread_updates_count &&
							!selectedActivities.filter(e => e === activity.activity_id)
								.length > 0 && (
								<Flex
									borderRadius='100%'
									bg='yellow.600'
									color='black'
									justifyContent='center'
									alignItems='center'
									textAlign='center'
									style={{ aspectRatio: '1/1' }}
								>
									{asset_unread_updates_count}
								</Flex>
							)}
					</GridItem>
					{/* <GridItem>
        </GridItem>
        <Grid justifyContent='end' gap='1.5rem'>
            <GridItem>
                {showDateCalendar(activity_datetime_end_deferred)}
            </GridItem>
            <GridItem>
                {!!asset_unread_updates_count &&
                    !selectedActivities.filter(e => e === activity.activity_id)
                        .length > 0 && (
                        <Flex
                            borderRadius='100%'
                            bg='yellow.600'
                            color='black'
                            justifyContent='center'
                            alignItems='center'
                            textAlign='center'
                            style={{ aspectRatio: '1/1' }}
                        >
                            {asset_unread_updates_count}
                        </Flex>
                    )}
            </GridItem>
            {/* <GridItem>
{!!asset_unread_mention_count && (
  <Flex
    borderRadius="100%"
    bg="yellow.600"
    color="black"
    justifyContent="center"
    alignItems="center"
    textAlign="center"
    style={{ aspectRatio: '1/1' }}
  >
    {asset_unread_mention_count}
  </Flex>
)}
</GridItem> */}
				</Grid>
			</Grid>
			<Flex
				fontSize='0.75rem'
				bg='#F2F3F8'
				alignItems='center'
				borderRadius='0px 0px 10px 10px'
				pt='0.625rem'
				pb='0.625rem'
			>
				<Box ml='1.25rem'>
					<SVGIcon
						iconName='WorkflowSvg'
						svgProps={{
							width: '16',
							height: '16',
							viewBox: '0 0 16 16',
						}}
					/>
				</Box>
				<Text as='span' fontWeight='500' color='black' ml='1rem'>
					{activity_type_category_name}
				</Text>
				<Icon as={CiClock2} w='1rem' h='1rem' color='black' ml='1rem' />
				<Text as='span' fontWeight='400' color='black' ml='0.5rem'>
					{timePassed}
				</Text>
				<CircularProgress
					value={completion || 0}
					color='#7ABE73'
					size='2rem'
					ml='auto'
					mr='1.25rem'
					trackColor='#E6E6E6'
				>
					<CircularProgressLabel fontSize='0.6rem'>
						{completion || 0}%
					</CircularProgressLabel>
				</CircularProgress>
			</Flex>
		</Card>
	)
}

export { ActivityListItem }
